import Settings from './container'
export { Settings }
export default Settings